module.exports = __webpack_public_path__ + "img/sparks-06.e32c020c.png";